/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetMonthlyDrivingInfoResponse } from '../models/ApiResponseGetMonthlyDrivingInfoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class JwtControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * My Token 토큰 인증
   * My Token 인증
   * @returns ApiResponseGetMonthlyDrivingInfoResponse OK
   * @throws ApiError
   */
  public validateMyToken({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<ApiResponseGetMonthlyDrivingInfoResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/jwt/validation/my',
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * My Token 토큰 인증
   * My Token 인증
   * @returns ApiResponseGetMonthlyDrivingInfoResponse OK
   * @throws ApiError
   */
  public validateMyToken1({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<ApiResponseGetMonthlyDrivingInfoResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/jwt/validation/my/',
      headers: {
        'Authorization': authorization,
      },
    });
  }
}
